const gtmEvent = obj => (window.dataLayer || []).push(obj)

export default gtmEvent
